import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

function Nav() {
  return (
    <nav style={{ padding: "20px", background: "#f0f0f0", marginBottom: "20px" }}>
      <Link to="/" style={{ marginRight: "15px" }}>Home</Link>
      <Link to="/about" style={{ marginRight: "15px" }}>About</Link>
      <Link to="/contact">Contact</Link>
    </nav>
  );
}

function Home() {
  return (
    <div>
      <h1>Home</h1>
      <p>This is a sample React app hosted on a private GCS bucket.</p>
      <p>If you can see this page, the Cloud CDN + Internet NEG + Load Balancer setup is working.</p>
    </div>
  );
}

function About() {
  return (
    <div>
      <h1>About</h1>
      <p>This page tests SPA routing.</p>
      <p>If you navigated here directly (or refreshed the page) and it still works, the URL map rewrite to index.html is working correctly.</p>
    </div>
  );
}

function Contact() {
  return (
    <div>
      <h1>Contact</h1>
      <p>Another route to test SPA fallback.</p>
    </div>
  );
}

function NotFound() {
  return (
    <div>
      <h1>404</h1>
      <p>This route doesn't exist, but you still got index.html served. SPA routing is working.</p>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Nav />
      <div style={{ padding: "20px" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
